module.exports = __webpack_public_path__ + "img/12.786765d3.jpg";